import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/shield.png'


const _withScopeId = n => (_pushScopeId("data-v-09213288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "reset" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nova senha", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imagem de um escudo verde."
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Criar nova senha", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Digite abaixo a nova senha que você quer criar para acessar o sistema.", -1))
const _hoisted_8 = { action: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "Crie uma nova senha *", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm-new-password" }, "Repita a nova senha *", -1))
const _hoisted_11 = ["disabled"]

import { isPerformingRequest, useAxios } from '@/api/axios'
import Loader from '@/components/loader/Loader.vue'
import router from '@/router'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
// import { toast } from 'vue3-toastify';

/* Starts at the top of the page */

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    token: {},
    email: {}
  },
  setup(__props: any) {

window.scrollTo({
  top: 0,
  behavior: 'auto'
})

const route = useRoute()
const props = __props
const resetPasswordForm = ref({ password: '', password_confirmation: '', token: props.token, email: route.query.email })
const axios = useAxios()

function resetPassword () {
  axios.post('/reset-password', resetPasswordForm.value)
    .then(() => {
      // toast.success('Senha redefinida com sucesso');
      router.push({ name: 'login' })
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'login' }))),
        class: "back"
      }, _hoisted_4),
      _createElementVNode("main", null, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("form", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((resetPasswordForm.value.password) = $event)),
              type: "password",
              placeholder: "Com pelo menos 6 caracteres",
              name: "new-password",
              id: "new-password"
            }, null, 512), [
              [_vModelText, resetPasswordForm.value.password]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resetPasswordForm.value.password_confirmation) = $event)),
              type: "password",
              placeholder: "A mesma do campo anterior",
              name: "confirm-new-password",
              id: "confirm-new-password"
            }, null, 512), [
              [_vModelText, resetPasswordForm.value.password_confirmation]
            ])
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("input", {
              autocomplete: "off",
              disabled: !resetPasswordForm.value.password || !resetPasswordForm.value?.password_confirmation || (resetPasswordForm.value.password != resetPasswordForm.value?.password_confirmation) || resetPasswordForm.value.password?.length < 6,
              type: "button",
              value: "Criar",
              onClick: resetPassword
            }, null, 8, _hoisted_11)
          ])
        ])
      ])
    ]),
    (_unref(isPerformingRequest))
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          zIndex: 99
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})